import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { ModelsResponse, Provider } from "./types";

export const useModels = (userToken: string, workspace_id: string) => {
  return useQuery(
    ["models", workspace_id],
    async (): Promise<ModelsResponse> => {
      const response = await fetch(ENDPOINTS.models(workspace_id), {
        headers: jsonAuthHeaders(userToken),
        method: "GET",
      });
      return handleResponse(response).then(
        (data) => data.results as Provider[],
      );
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  );
};
